export default __webpack_public_path__ + "static/media/welovemovies_screen.903ba61b.png";